// src/data/lo-trinh.js — phiên bản 2
// Thay đổi so với bản 1:
// - Mỗi trạm có `viec`: danh sách việc cần làm theo thứ tự, kèm "cần chuẩn bị gì"
//   và nhãn nút. Trang Lộ trình hiển thị việc trước, tài liệu sau.
// - Trạm 2 có `theoNganh`: chỉ hiện bài và mẫu của ngành người dùng chọn.
// - `TIEU_CHI_SANG_VIEC` + `goiYTuKetQua()`: nối kết quả công cụ Điểm sẵn sàng
//   với trạm và việc cụ thể.
// - Giữ nguyên các mảng congCu / playbook / mau và các hàm cũ để nhãn "Trạm x/5"
//   trên trang bài, công cụ, mẫu không bị ảnh hưởng.
//
// Bài Playbook viết mới qua /admin/playbook sẽ không có trạm cho tới khi
// thêm slug vào đây. Giao diện ẩn nhãn trạm khi không tìm thấy.

// Mỗi việc trỏ tới một đích: { loai: 'congCu' | 'playbook' | 'mau' | 'nganh', slug }
// 'nganh' nghĩa là đích phụ thuộc ngành người dùng chọn (xem theoNganh).

export const TRAM = [
  {
    so: 0,
    id: 'xuat-phat',
    laXuatPhat: true, // hiển thị trong phần đầu trang, không thành một trạm riêng
    ten: 'Điểm xuất phát',
    cauHoi: 'Mình nên bắt đầu từ đâu?',
    mangVe: 'Biết nên bắt đầu từ trạm nào',
    congCuChinh: 'diem-san-sang-goi-von',
    congCu: ['diem-san-sang-goi-von'],
    playbook: [],
    huongDan: ['goi-von-lan-dau'],
    mau: [],
    viec: [],
  },
  {
    so: 1,
    id: 'tien-va-thoi-gian',
    ten: 'Tiền và thời gian',
    cauHoi: 'Còn bao lâu tiền, và cần gọi bao nhiêu?',
    mangVe: 'Biết tiền hiện có đủ dùng bao lâu và cần gọi bao nhiêu',
    // Bản đồ trang chủ: biểu tượng của trạm và tên ngắn của kết quả mang về.
    bieuTuong: 'dong-ho',
    ketQuaNgan: 'Runway và số vốn cần gọi',
    congCuChinh: 'tinh-runway',
    congCu: ['tinh-runway', 'goi-bao-nhieu'],
    viec: [
      {
        ten: 'Tính số tháng còn đủ tiền hoạt động',
        chuanBi: 'Tiền mặt hiện có, thu và chi mỗi tháng.',
        dich: { loai: 'congCu', slug: 'tinh-runway' },
        nhan: 'Tính runway',
      },
      {
        ten: 'Xác định số vốn cần gọi',
        chuanBi: 'Kết quả runway ở việc 1 và cột mốc muốn đạt trong 12–18 tháng.',
        dich: { loai: 'congCu', slug: 'goi-bao-nhieu' },
        nhan: 'Tính số vốn cần gọi',
      },
    ],
    playbook: [
      'goi-von-qua-som-bon-cai-gia',
      'founder-con-4-thang-runway-nen-goi-von-the-nao',
      'startup-nen-goi-bao-nhieu-von-cho-18-thang',
      'tu-pre-series-a-len-series-a-o-viet-nam',
      'mo-xe-slide-use-of-funds',
    ],
    mau: [],
  },
  {
    so: 2,
    id: 'doanh-nghiep-bang-con-so',
    ten: 'Doanh nghiệp bằng con số',
    cauHoi: 'Mô hình kinh doanh của mình có đứng được về số không?',
    mangVe: 'Một mô hình tài chính của chính mình, giả định đã được soát',
    // Bản đồ trang chủ: biểu tượng của trạm và tên ngắn của kết quả mang về.
    bieuTuong: 'bieu-do',
    ketQuaNgan: 'Mô hình tài chính đã soát',
    congCuChinh: 'kiem-tra-gia-dinh-kinh-te-don-vi',
    congCu: ['kiem-tra-gia-dinh-kinh-te-don-vi', 'chi-so-tang-truong'],
    viec: [
      {
        ten: 'Soát giả định về giá, chi phí và giữ chân khách',
        chuanBi: 'Giá bán, chi phí để có một khách, tỷ lệ khách quay lại. Ước tính cũng được.',
        dich: { loai: 'congCu', slug: 'kiem-tra-gia-dinh-kinh-te-don-vi' },
        nhan: 'Soát giả định',
      },
      {
        ten: 'Dựng mô hình tài chính theo ngành của bạn',
        chuanBi: 'Giả định đã soát ở việc 1.',
        dich: { loai: 'nganh' }, // mở mẫu Excel của ngành đã chọn
        nhan: 'Mở mẫu cho ngành của tôi',
      },
      {
        // Thêm vào cuối: tiến độ việc lưu theo thứ tự, chèn giữa sẽ lệch dấu "xong".
        ten: 'Đo tốc độ tăng trưởng từ doanh thu thật',
        chuanBi: 'Doanh thu từng tháng, ít nhất 3 tháng gần nhất. Số khách nếu có.',
        khi: 'Bỏ qua nếu chưa có doanh thu.',
        dich: { loai: 'congCu', slug: 'chi-so-tang-truong' },
        nhan: 'Tính chỉ số tăng trưởng',
      },
    ],
    // Toàn bộ bài của trạm (giữ đủ để tramCuaBai() vẫn tìm thấy bài theo ngành)
    playbook: [
      'xay-mo-hinh-tai-chinh-cho-startup',
      'ba-bao-cao-tai-chinh-cua-startup',
      'mo-hinh-tai-chinh-cho-startup-saas',
      'mo-hinh-tai-chinh-cho-chuoi-fnb',
      'mo-hinh-tai-chinh-cho-thuong-mai-dien-tu',
    ],
    mau: [
      'mo-hinh-tai-chinh-saas',
      'mo-hinh-tai-chinh-chuoi-fnb',
      'mo-hinh-tai-chinh-thuong-mai-dien-tu',
      'mo-hinh-tai-chinh-36-thang-saas',
    ],
    playbookChung: [
      'xay-mo-hinh-tai-chinh-cho-startup',
      'ba-bao-cao-tai-chinh-cua-startup',
    ],
    theoNganh: {
      saas: {
        ten: 'SaaS',
        playbook: ['mo-hinh-tai-chinh-cho-startup-saas'],
        mauChinh: 'mo-hinh-tai-chinh-saas',
        mauThem: ['mo-hinh-tai-chinh-36-thang-saas'],
      },
      fnb: {
        ten: 'F&B / bán lẻ chuỗi',
        playbook: ['mo-hinh-tai-chinh-cho-chuoi-fnb'],
        mauChinh: 'mo-hinh-tai-chinh-chuoi-fnb',
        mauThem: [],
      },
      tmdt: {
        ten: 'Thương mại điện tử / D2C',
        playbook: ['mo-hinh-tai-chinh-cho-thuong-mai-dien-tu'],
        mauChinh: 'mo-hinh-tai-chinh-thuong-mai-dien-tu',
        mauThem: [],
      },
      khac: {
        ten: 'Ngành khác',
        playbook: [],
        mauChinh: null, // dẫn tới bài "Xây mô hình tài chính" thay cho mẫu
        mauThem: [],
      },
    },
  },
  {
    so: 3,
    id: 'co-phan-dinh-gia-phap-ly',
    ten: 'Cổ phần, định giá, pháp lý',
    cauHoi: 'Ai sở hữu bao nhiêu, trước và sau vòng này?',
    mangVe: 'Cap table sau vòng, khoảng định giá và danh sách giấy tờ còn thiếu',
    // Bản đồ trang chủ: biểu tượng của trạm và tên ngắn của kết quả mang về.
    bieuTuong: 'co-phan',
    ketQuaNgan: 'Cap table sau vòng',
    congCuChinh: 'chia-co-phan-dong-sang-lap',
    congCu: [
      'chia-co-phan-dong-sang-lap',
      'dinh-gia-pre-seed',
      'dinh-gia-co-doanh-thu',
      'bang-co-phan-va-pha-loang',
      'mo-phong-vong-goi-von',
      'safe-va-trai-phieu-chuyen-doi',
      'ho-so-phap-ly-khoi-nghiep',
    ],
    // Trạm nhiều công cụ nhất: trang danh mục chia thành ba nhóm nhỏ.
    nhomCongCu: [
      { ten: 'Cổ phần', slugs: ['chia-co-phan-dong-sang-lap', 'bang-co-phan-va-pha-loang', 'mo-phong-vong-goi-von', 'safe-va-trai-phieu-chuyen-doi'] },
      { ten: 'Định giá', slugs: ['dinh-gia-pre-seed', 'dinh-gia-co-doanh-thu'] },
      { ten: 'Pháp lý', slugs: ['ho-so-phap-ly-khoi-nghiep'] },
    ],
    viec: [
      {
        ten: 'Chốt tỷ lệ và vesting giữa các nhà sáng lập',
        chuanBi: 'Vai trò, thời gian và phần đóng góp của từng người.',
        khi: 'Bỏ qua nếu nhóm đã có thoả thuận bằng văn bản.',
        dich: { loai: 'congCu', slug: 'chia-co-phan-dong-sang-lap' },
        nhan: 'Soát cách chia',
      },
      {
        ten: 'Ước khoảng định giá cho vòng này',
        chuanBi: 'Đội ngũ, sản phẩm và bằng chứng nhu cầu hiện có. Nếu đã có doanh thu: doanh thu 12 tháng và bội số của vài công ty cùng ngành.',
        dich: { loai: 'congCu', slug: 'dinh-gia-pre-seed' },
        nhan: 'Ước định giá',
        phu: [
          { slug: 'dinh-gia-co-doanh-thu', ghiChu: 'Đã có doanh thu đều đặn: định giá theo bội số và phương pháp VC' },
        ],
      },
      {
        ten: 'Xem cap table sau vòng',
        chuanBi: 'Số vốn cần gọi (Trạm 1) và khoảng định giá (việc 2).',
        dich: { loai: 'congCu', slug: 'bang-co-phan-va-pha-loang' },
        nhan: 'Lập cap table',
        phu: [
          { slug: 'mo-phong-vong-goi-von', ghiChu: 'Muốn thử nhanh nhiều mức định giá' },
          { slug: 'safe-va-trai-phieu-chuyen-doi', ghiChu: 'Chỉ khi đã hoặc sắp ký SAFE, trái phiếu chuyển đổi' },
        ],
      },
      {
        ten: 'Rà giấy tờ pháp lý cần có trước khi nhận vốn',
        chuanBi: 'Loại hình doanh nghiệp và điều lệ hiện tại.',
        dich: { loai: 'congCu', slug: 'ho-so-phap-ly-khoi-nghiep' },
        nhan: 'Rà hồ sơ pháp lý',
      },
    ],
    playbook: [
      'cap-table-pha-loang-vong-dau',
      'dinh-gia-startup-dcf-va-cac-phuong-phap',
      'vi-sao-nha-dau-tu-thien-than-doi-loi-nhuan-30-lan',
      'dinh-gia-tren-giay-va-dinh-gia-that',
    ],
    mau: ['cap-table-pha-loang-safe', 'dinh-gia-startup-dcf'],
  },
  {
    so: 4,
    id: 'ho-so-trinh-bay',
    ten: 'Hồ sơ trình bày',
    cauHoi: 'Nhà đầu tư đọc deck của mình sẽ hiểu gì?',
    mangVe: 'Một pitch deck đã chấm, biết slide nào cần sửa',
    // Bản đồ trang chủ: biểu tượng của trạm và tên ngắn của kết quả mang về.
    bieuTuong: 'trinh-chieu',
    ketQuaNgan: 'Pitch deck đã chấm',
    congCuChinh: 'pitch-deck-10-slide',
    congCu: ['pitch-deck-10-slide', 'quy-mo-thi-truong'],
    viec: [
      {
        ten: 'Chấm pitch deck theo khung 10 slide',
        chuanBi: 'Bản deck hiện có, hoặc ý chính cho từng slide nếu chưa có deck.',
        dich: { loai: 'congCu', slug: 'pitch-deck-10-slide' },
        nhan: 'Chấm deck',
      },
      {
        ten: 'Làm chắc slide thị trường',
        chuanBi: 'Số khách hàng tiềm năng và giá bán dự kiến.',
        khi: 'Nên làm nếu slide thị trường đang dùng con số lấy từ báo cáo ngành.',
        dich: { loai: 'congCu', slug: 'quy-mo-thi-truong' },
        nhan: 'Tính quy mô thị trường',
      },
    ],
    playbook: [
      'quy-nhin-gi-trong-5-phut-dau-pitch-deck',
      'pitch-deck-tot-va-chua-tot',
      'vi-sao-khong-co-doi-thu-la-cau-tra-loi-nguy-hiem',
    ],
    mau: [],
  },
  {
    so: 5,
    id: 'tim-quy-va-tiep-can',
    ten: 'Tìm quỹ và tiếp cận',
    cauHoi: 'Gửi cho ai, và viết gì trong email đầu tiên?',
    mangVe: 'Danh sách quỹ phù hợp và email tiếp cận đầu tiên',
    // Bản đồ trang chủ: biểu tượng của trạm và tên ngắn của kết quả mang về.
    bieuTuong: 'gui',
    ketQuaNgan: 'Danh sách quỹ và email đầu tiên',
    congCuChinh: 'quy-phu-hop',
    congCu: ['quy-phu-hop', 'doc-term-sheet'],
    viec: [
      {
        ten: 'Lọc quỹ phù hợp với giai đoạn, ngành và địa bàn',
        chuanBi: 'Giai đoạn, ngành và số vốn cần gọi.',
        dich: { loai: 'congCu', slug: 'quy-phu-hop' },
        nhan: 'Tìm quỹ phù hợp',
      },
      {
        ten: 'Viết email tiếp cận đầu tiên',
        chuanBi: 'Danh sách quỹ ở việc 1 và một câu mô tả công ty.',
        dich: { loai: 'playbook', slug: 'email-tiep-can-quy-kem-vi-du' },
        nhan: 'Xem cách viết và ví dụ',
      },
      {
        ten: 'Theo dõi các quỹ đã liên hệ',
        chuanBi: 'Danh sách quỹ đã gửi email, ngày gửi và người liên hệ.',
        dich: { loai: 'mau', slug: 'theo-doi-tiep-can-nha-dau-tu' },
        nhan: 'Tải bảng theo dõi',
      },
      {
        ten: 'Đọc kỹ term sheet trước khi ký',
        chuanBi: 'Bản term sheet nhà đầu tư gửi.',
        khi: 'Làm khi đã nhận term sheet.',
        dich: { loai: 'congCu', slug: 'doc-term-sheet' },
        nhan: 'Đọc term sheet',
      },
    ],
    playbook: [
      'email-tiep-can-quy-kem-vi-du',
      'quy-tiep-nhan-ho-so-den-giai-ngan',
      'nam-hieu-nham-khi-goi-von-quy-de-mo-rong',
      'tai-tro-ung-dung-ai-natif-2026',
    ],
    mau: ['theo-doi-tiep-can-nha-dau-tu', 'bo-ho-so-tham-dinh-data-room'],
  },
];

// ---------------------------------------------------------------------------
// Nối công cụ Điểm sẵn sàng với lộ trình.
// Nối theo TIÊU CHÍ (key trong shared/rubrics/readinessPreseed.js), không theo
// trục: cùng trục "Hồ sơ và tài chính" nhưng thiếu runway và thiếu pháp nhân
// là hai việc ở hai trạm khác nhau.
// `thieuNoiDung: true`: site CHƯA có công cụ xử lý tiêu chí này. Trang kết quả
// nói thẳng điều đó, rồi mới gợi ý việc làm được tiếp theo.
const TRACTION = '/playbook/quy-nhin-gi-trong-5-phut-dau-pitch-deck#phan-5';
const NAM_T = '/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai';

export const TIEU_CHI_SANG_VIEC = {
  // Đội ngũ
  VESTING_SIGNED: { tram: 3, viec: 0, lyDo: 'nhà đầu tư hỏi rất sớm ai giữ bao nhiêu cổ phần và đã có vesting chưa.' },
  FULLTIME_FOUNDER: { thieuNoiDung: true, ghiChu: 'Chưa có ai làm toàn thời gian là điều công cụ không sửa giúp được. Hầu hết quỹ angel và pre-seed chờ ít nhất một người cam kết toàn thời gian.' },
  DOMAIN_EXPERTISE: { thieuNoiDung: true, ghiChu: 'Thiếu người am hiểu ngành thường được bù bằng một cố vấn hoặc đồng sáng lập đúng ngành. Fundraising.vn chưa có công cụ cho việc này.' },
  TEAM_SIZE: { thieuNoiDung: true, ghiChu: 'Founder một mình vẫn gọi vốn được, nhưng cần giải thích rõ ai sẽ cùng làm. Fundraising.vn chưa có công cụ cho việc này.' },
  // Vấn đề và giải pháp
  ONE_LINER: { tram: 4, viec: 0, lyDo: 'nhà đầu tư cần hiểu bạn làm gì, cho ai ngay ở slide đầu.' },
  PROBLEM_STATED: { tram: 4, viec: 0, lyDo: 'vấn đề cần được nói rõ trong vài slide đầu, trước khi nhà đầu tư hình thành ấn tượng.' },
  SCALE_LEVERAGE: { thieuNoiDung: true, docThem: NAM_T, ghiChu: 'Fundraising.vn chưa có công cụ riêng cho việc này. Bài dưới đây giải thích vì sao quỹ cần công ty lớn được mà chi phí không phình theo, và cần đưa con số nào vào deck.' },
  MOAT: { thieuNoiDung: true, docThem: NAM_T, ghiChu: 'Hào phòng thủ không sửa bằng công cụ được, nhưng cần nói rõ trong deck. Bài dưới đây liệt kê năm loại lợi thế khó sao chép và bằng chứng nên kèm.' },
  PRODUCT_EXISTS: { thieuNoiDung: true, ghiChu: 'Chưa có nguyên mẫu chạy được thì việc cần làm là làm sản phẩm, không phải chỉnh hồ sơ.' },
  // Bằng chứng có người cần
  EVIDENCE_COUNT: { thieuNoiDung: true, docThem: TRACTION, ghiChu: 'Fundraising.vn chưa có công cụ riêng để gom bằng chứng nhu cầu. Phần "Traction ở giai đoạn sớm" trong bài này liệt kê những loại bằng chứng startup chưa có doanh thu vẫn có thể có.' },
  PAID_EVIDENCE: { thieuNoiDung: true, docThem: TRACTION, ghiChu: 'Một khách trả tiền hoặc một thư cam kết đáng giá hơn nhiều lời khen. Fundraising.vn chưa có công cụ riêng cho việc này; bài dưới đây gợi ý nên bắt đầu từ đâu.' },
  // Thị trường
  SOM_DEFINED: { tram: 4, viec: 1, lyDo: 'nhà đầu tư cần biết phần thị trường bạn thực sự chiếm được.' },
  BOTTOM_UP: { tram: 4, viec: 1, lyDo: 'quy mô thị trường tính từ dưới lên thuyết phục hơn con số lấy từ báo cáo ngành.' },
  SALES_CHANNEL: { thieuNoiDung: true, ghiChu: 'Fundraising.vn chưa có công cụ riêng để thử kênh bán hàng. Cách nhanh nhất là chọn một hai kênh, chạy thử với ngân sách nhỏ và ghi lại chi phí cho mỗi khách; công cụ kinh tế đơn vị giúp kiểm tra con số đó có lãi không.' },
  // Hồ sơ và tài chính
  RUNWAY_OK: { tram: 1, viec: 0, lyDo: 'mọi con số khác (số vốn cần gọi, định giá, cap table) đều bắt đầu từ runway.' },
  RAISE_AMOUNT: { tram: 1, viec: 1, lyDo: 'bạn cần một con số gọi vốn có thể bảo vệ trước nhà đầu tư.' },
  USE_OF_FUNDS: { tram: 1, viec: 1, lyDo: 'nhà đầu tư muốn thấy tiền đưa công ty tới cột mốc nào.' },
  INCORPORATED: { tram: 3, viec: 3, lyDo: 'nhà đầu tư chỉ rót tiền vào một pháp nhân.' },
  IP_ASSIGNED: { tram: 3, viec: 3, lyDo: 'sở hữu trí tuệ nằm ngoài công ty là điểm quỹ sẽ dừng lại khi thẩm định.' },
};

// Khi không còn tiêu chí nào chưa đạt: chuyển thẳng sang tìm quỹ.
export const KHI_DU_SAN_SANG = {
  tram: 5,
  viec: 0,
  lyDo: 'hồ sơ của bạn đã khá đủ; bước tiếp theo là chọn đúng quỹ để gửi.',
};

/**
 * Gợi ý điểm bắt đầu từ kết quả engine readinessScore (res.nextActions đã
 * sắp theo số điểm lấy lại được, ô chưa điền xếp cuối).
 * Trả về:
 *   { tram, viec, lyDo, tieuChi }             — gợi ý làm được ngay
 *   { thieu: { tieuChi, ghiChu, docThem } }   — kèm khi việc quan trọng nhất
 *                                               chưa có công cụ trên site
 *   null                                      — chưa đủ dữ liệu để gợi ý
 */
export function goiYTuKetQua(res) {
  if (!res || res.loi || !Array.isArray(res.nextActions)) return null;
  const daDanhGia = res.nextActions.filter((a) => a.status !== 'CHUA_DIEN');
  if (res.coverage && res.coverage.pct < 50) return null;
  let thieu = null;
  for (const a of daDanhGia) {
    const m = TIEU_CHI_SANG_VIEC[a.key];
    if (!m) continue;
    if (m.thieuNoiDung) {
      if (!thieu) thieu = { tieuChi: a.label, ghiChu: m.ghiChu, docThem: m.docThem };
      continue;
    }
    return { tram: m.tram, viec: m.viec, lyDo: m.lyDo, tieuChi: a.label, thieu };
  }
  if (thieu) return { tram: null, thieu };
  return { ...KHI_DU_SAN_SANG, tieuChi: null, thieu: null };
}

// ---------------------------------------------------------------------------
// Hàm dùng chung (giữ tương thích với bản 1)

export const SO_TRAM = TRAM.filter((t) => t.so > 0).length; // 5

const theoSo = new Map(TRAM.map((t) => [t.so, t]));

export const layTram = (so) => theoSo.get(so) || null;

/** Chỉ 5 trạm thật, không gồm điểm xuất phát. */
export const cacTram = () => TRAM.filter((t) => t.so > 0);

function timTheo(loai, slug) {
  if (!slug) return null;
  return TRAM.find((t) => (t[loai] || []).includes(slug)) || null;
}

export const tramCuaBai = (slug) => timTheo('playbook', slug);
export const tramCuaCongCu = (slug) => timTheo('congCu', slug);
export const tramCuaMau = (slug) => timTheo('mau', slug);

export const tramTiepTheo = (tram) =>
  tram ? theoSo.get(tram.so + 1) || null : null;

export const nhanTram = (tram) =>
  !tram ? '' : tram.so === 0 ? tram.ten : `Trạm ${tram.so}/${SO_TRAM}: ${tram.ten}`;

export const linkTram = (tram) => `/lo-trinh#${tram.id}`;

/** Đường dẫn cho một việc. `nganh` chỉ cần cho đích loại 'nganh'. */
export function linkViec(tram, viec, nganh) {
  const d = viec?.dich;
  if (!d) return linkTram(tram);
  if (d.loai === 'congCu') return `/cong-cu/${d.slug}`;
  if (d.loai === 'playbook') return `/playbook/${d.slug}`;
  if (d.loai === 'mau') return `/mau/${d.slug}`;
  if (d.loai === 'nganh') {
    const n = tram.theoNganh?.[nganh];
    if (n?.mauChinh) return `/mau/${n.mauChinh}`;
    if (nganh === 'khac') return '/playbook/xay-mo-hinh-tai-chinh-cho-startup';
    return '/mau'; // chưa chọn ngành
  }
  return linkTram(tram);
}

/** Tài liệu hỗ trợ của trạm: bài và mẫu, trừ những thứ đã là đích của một việc. */
export function taiLieuHoTro(tram, nganh) {
  const dichViec = new Set((tram.viec || []).map((v) => v.dich?.slug).filter(Boolean));
  let playbook = tram.playbook;
  let mau = tram.mau;
  if (tram.theoNganh && nganh && tram.theoNganh[nganh]) {
    const n = tram.theoNganh[nganh];
    playbook = [...tram.playbookChung, ...n.playbook];
    mau = [n.mauChinh, ...n.mauThem].filter(Boolean);
  }
  return {
    playbook: playbook.filter((s) => !dichViec.has(s)),
    mau: mau.filter((s) => !dichViec.has(s)),
  };
}

/**
 * Việc tiếp theo sau khi dùng xong một công cụ, theo lộ trình.
 * - Công cụ là đích của việc k trong trạm → việc k+1 cùng trạm.
 * - Công cụ là công cụ phụ (`phu`) của việc k → cũng sang việc k+1.
 * - Việc cuối của trạm → việc đầu của trạm kế.
 * Trả về { tram, viec, stt, tongViec, sangTram } hoặc null (công cụ ngoài
 * lộ trình, công cụ ở Điểm xuất phát, hoặc việc cuối của trạm 5).
 */
export function viecTiepTheo(slugCongCu) {
  for (const t of cacTram()) {
    const i = (t.viec || []).findIndex(
      (v) =>
        (v.dich?.loai === 'congCu' && v.dich.slug === slugCongCu) ||
        (v.phu || []).some((p) => p.slug === slugCongCu),
    );
    if (i < 0) continue;
    if (i + 1 < t.viec.length) {
      return { tram: t, viec: t.viec[i + 1], stt: i + 2, tongViec: t.viec.length, sangTram: false };
    }
    const tiep = tramTiepTheo(t);
    if (!tiep || !tiep.viec?.length) return null;
    return { tram: tiep, viec: tiep.viec[0], stt: 1, tongViec: tiep.viec.length, sangTram: true };
  }
  return null;
}

export const tatCaSlug = () => ({
  congCu: TRAM.flatMap((t) => t.congCu),
  playbook: TRAM.flatMap((t) => t.playbook),
  mau: TRAM.flatMap((t) => t.mau),
});
